import React, { Component } from 'react';
import { array, bool, func, number, object, string } from 'prop-types';

import { connect } from 'react-redux';
import { showSlideout } from 'ps-components/Slideout/SlideoutReducer';
import EditRuleHeader from './EditRulePanelHeader/EditRuleHeader';
import FacetPanel from 'ps-components/FacetPanel/FacetPanel';
import DataCutsListPanel from './DataCutsListPanel/DataCutsListPanel';
import { areAllFacetsChecked, getQueryParams } from '../../../lib/facetHelpers';

import './EditRule.scss';
import { SLIDEOUTS } from '../../Slideout/Slideouts';

class EditRule extends Component {
  static propTypes = {
    actions: object,
    dataCuts: array,
    facets: array,
    isEditing: bool,
    isSelected: bool,
    ruleName: string,
    searchInputSearch: func,
    searchText: string,
    selectedRule: object,
    selectedRuleConnection: array,
    showSlideout: func,
    tempName: string,
    totalDataCutCount: number,
    loading: bool,
    offset: number
  };

  componentDidUpdate(prevProps, prevState) {
    const { actions, selectedRule } = this.props;
    if (selectedRule && selectedRule !== prevProps.selectedRule) {
      actions.setRuleName(selectedRule.name);
    }
  }

  UNSAFE_componentWillUpdate(nextProps, nextState) {
    const { actions, selectedRule, selectedRuleConnection } = this.props;

    if (
      !!Object.keys(selectedRule).length &&
      selectedRule.id === nextProps.selectedRule.id &&
      (selectedRuleConnection.length !== nextProps.selectedRuleConnection.length ||
        selectedRule.name !== nextProps.selectedRule.name ||
        selectedRule.lowerLimitEE !== nextProps.selectedRule.lowerLimitEE ||
        selectedRule.lowerLimitCO !== nextProps.selectedRule.lowerLimitCO)
    ) {
      actions.getAuditInfo(selectedRule);
    }
  }

  addDataCutToRule = (dataCut, priority) => {
    const { actions, selectedRule } = this.props;
    actions.addDataCutToRule(selectedRule, dataCut, priority);
  };

  cancelRuleNameEditing = () => {
    const { cancelRuleNameEditing } = this.props.actions;
    const { selectedRule, ruleName } = this.props;
    if (ruleName === '') cancelRuleNameEditing(selectedRule.name);
    else cancelRuleNameEditing();
  };

  clearSearch = () => {
    const { actions } = this.props;

    actions.searchInputSearch('');
    actions.setFacetText('');
  };

  deleteDataCutFromRule = dataCut => {
    const { actions, selectedRule } = this.props;
    const dataCutConnectionId = this.getConnectionId(dataCut);

    actions.deleteDataCutFromRule(selectedRule, dataCutConnectionId.id);
  };

  getConnectionId = dataCut => {
    const { selectedRuleConnection } = this.props;

    return selectedRuleConnection.find(connection => {
      if (connection.dataCut.id === dataCut.id) {
        return connection;
      }
    });
  };

  onEnter = e => {
    const key = e.which || e.keyCode;
    if (key === 13) this.saveRuleName();
  };

  openJobMatchingSlideout = () => {
    const { showSlideout } = this.props;
    showSlideout(SLIDEOUTS.JOB_MATCHING_SLIDEOUT);
  };

  pageDataCuts = (first, newAfter) => {
    const { actions } = this.props;
    actions.pageList(first, newAfter);
  };

  saveRuleName = () => {
    const { updateRule, saveRuleName } = this.props.actions;
    const { selectedRule, ruleName, tempName } = this.props;

    if (tempName.length > 1) {
      const newName = tempName.trim();
      saveRuleName(newName);
      updateRule({ id: selectedRule.id, name: tempName });
    } else {
      saveRuleName(ruleName);
    }
  };

  setName = e => {
    const { setTempRuleName } = this.props.actions;
    const tempName = e.target.value.length ? e.target.value : ' ';
    setTempRuleName(tempName);
  };

  toggleShowSelected = () => {
    const { actions, selectedRule } = this.props;
    actions.toggleShowSelected(selectedRule.dataCuts);
  };

  updateDataCutToRule = (dataCut, priority) => {
    const { actions } = this.props;
    const dataCutConnectionId = this.getConnectionId(dataCut);

    actions.updateDataCutToRule(dataCutConnectionId.id, priority);
  };

  handleReset = () => {
    const { actions, name } = this.props;

    actions.search({
      params: getQueryParams(name),
      clear: true
    });

    actions.setFacetText('');
  };

  render() {
    const {
      actions,
      dataCuts,
      facets,
      facetSelection,
      isEditing,
      isLoaded,
      isLoading,
      isSelected,
      lastFacetFilteredID,
      lastQueryParams,
      ruleName,
      searchText,
      selectedRule,
      selectedRuleConnection,
      showZeros,
      tempName,
      totalDataCutCount
    } = this.props;
    const { toggleShowSelected, setFacetText, startEditingRuleName } = this.props.actions;
    const hasConnections = !!selectedRuleConnection.length;
    const isDisabled = !hasConnections;
    const showResetButton =
      areAllFacetsChecked(facets, facetSelection) || (lastQueryParams && lastQueryParams.es_query !== '');

    return (
      <section className="edit__rule-panel">
        <EditRuleHeader
          cancelRuleNameEditing={this.cancelRuleNameEditing}
          isDisabled={isDisabled}
          isEditing={isEditing}
          onEnter={this.onEnter}
          openJobMatchingSlideout={this.openJobMatchingSlideout}
          ruleName={ruleName}
          saveRuleName={this.saveRuleName}
          setRuleName={this.setName}
          startEditingRuleName={startEditingRuleName}
          tempName={tempName}
        />
        <div className="edit__body">
          <FacetPanel
            className="datacut__facets"
            facetItemClick={actions.facetItemClick}
            facetReset={actions.facetReset}
            facets={facets}
            facetSelection={facetSelection}
            isDisabled={!isSelected}
            isLoaded={isLoaded}
            lastFacetFilteredID={lastFacetFilteredID}
            limit={5}
            resetSearch={this.handleReset}
            showFacetSectionSearch={true}
            showResetButton={showResetButton}
            showZeros={showZeros}
          />
          <DataCutsListPanel
            addDataCutToRule={this.addDataCutToRule}
            clearSearch={this.clearSearch}
            dataCuts={dataCuts}
            deleteDataCutFromRule={this.deleteDataCutFromRule}
            isSelected={isSelected}
            isLoaded={isLoaded}
            isLoading={isLoading}
            pageDataCuts={this.pageDataCuts}
            search={actions.search}
            searchText={searchText}
            selectedRuleConnection={selectedRuleConnection}
            setSearchText={setFacetText}
            toggleShowSelected={this.toggleShowSelected}
            totalDataCutCount={totalDataCutCount}
            updateDataCutToRule={this.updateDataCutToRule}
            searchInputSearch={this.props.searchInputSearch}
            offset={this.props.offset}
          />
        </div>
      </section>
    );
  }
}

export default connect(null, { showSlideout })(EditRule);
